import React, { useEffect, useState } from 'react';
import { RefreshCw, Plug } from 'lucide-react';
import opsService from '../../../services/opsService';

export default function WorldPacPanel({ onSynced }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    try { setStatus(await opsService.worldpacStatus()); } catch { /* keep prior */ }
  };
  useEffect(() => { load(); }, []);

  const syncNow = async () => {
    setBusy(true); setError(null);
    try {
      await opsService.worldpacSyncNow();
      setTimeout(() => { load(); onSynced && onSynced(); }, 1500);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Sync failed');
    } finally {
      setBusy(false);
    }
  };

  const lr = status?.last_run;
  return (
    <div className="bg-surface-card rounded-card shadow-elevation-1 border p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold text-ink-soft flex items-center gap-2">
          <Plug className="w-5 h-5" /> WorldPac sync
        </h3>
        <button onClick={syncNow} disabled={busy || !status?.enabled}
                className="flex items-center gap-2 px-4 py-2 bg-accent text-white rounded-lg hover:bg-accent-hover disabled:opacity-50">
          <RefreshCw className={`w-4 h-4 ${busy ? 'animate-spin' : ''}`} /> Sync now
        </button>
      </div>
      {!status?.enabled && (
        <p className="text-ink-muted mt-2">Add WorldPac credentials and set WORLDPAC_ENABLED=true to enable.</p>
      )}
      {status?.enabled && (
        <p className="text-ink-muted mt-2">
          {lr ? `Last run: ${lr.status} · ${lr.orders_synced ?? 0} orders, ${lr.invoices_synced ?? 0} invoices${lr.error ? ` · ${lr.error}` : ''}`
              : 'No sync runs yet.'}
        </p>
      )}
      {error && <p className="text-danger mt-2">{error}</p>}
    </div>
  );
}
